import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from './../../../services/auth.service';
import { StatisticsService } from './../../../rest/api/statistics.service';

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss']
})
export class StatisticsComponent implements OnInit {
  @Input() singleSpaceData;
  accessToken: any;
  langShortCode: any;
  statisticData: any;
  statisticCount: any;
  totalCount: number;
  totalSpaces: number;
  totalImpressions: number;
  totalVisitors: number;
  itemsPerPage = 5;
  currentPage = 1;
  dataLoader = true;
  filter = '';
  page = 1;
  statisticsFrom: any;
  statisticsTo: any;

  selectedHotspotInfoData: any;

  constructor(
    private authService: AuthService,
    private statisticService: StatisticsService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.langShortCode = localStorage.getItem('language') ? localStorage.getItem('language') : undefined;
  }

  ngOnInit() {
    this.getStatistics(this.filter);
  }

  getStatistics(data) {
    this.dataLoader = true;
    this.currentPage = 1;
    this.filter = data;
    this.getStatisticsList(this.page, this.itemsPerPage, data);
  }

  getStatisticsList(page, limit, filter) {
    this.statisticService.getStatistics({
      Authorization: this.accessToken,
      page: page,
      paginate: limit,
      filter: filter || undefined
    }).subscribe((response: any) => {
      this.dataLoader = false;
      this.totalCount = response && response.meta && response.meta.pagination && response.meta.pagination.total ? response.meta.pagination.total : 0;
      this.totalSpaces = response && response.meta && response.meta.totals && response.meta.totals.spaces ? response.meta.totals.spaces : 0;
      this.totalImpressions = response && response.meta && response.meta.totals && response.meta.totals.impressions ? response.meta.totals.impressions : 0;
      this.totalVisitors = response && response.meta && response.meta.totals && response.meta.totals.visitors ? response.meta.totals.visitors : 0;
      this.statisticsFrom = response && response.meta && response.meta.totals && response.meta.totals.from ? response.meta.totals.from : '';
      this.statisticsTo = response && response.meta && response.meta.totals && response.meta.totals.to ? response.meta.totals.to : '';
      this.statisticData = response && response.data ? response.data : [];
      this.statisticCount = response && response.data && response.data.hotspot_info ? response.data.hotspot_info : undefined;
    }, err => {
      this.dataLoader = false;
      this.totalCount = 0;
      this.totalSpaces = 0;
      this.totalImpressions = 0;
      this.totalVisitors = 0;
      this.statisticsFrom = '';
      this.statisticsTo = '';
      this.statisticData = [];
    });
  }

  pageChanged(event) {
    this.dataLoader = true;
    this.currentPage = event;
    this.getStatisticsList(event, this.itemsPerPage, this.filter);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  selectHotspotCount(data) {
    this.selectedHotspotInfoData = data;
  }

  hotspotCountClose() {
    this.selectedHotspotInfoData = undefined;
  }

}
